import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useAppDispatch, useAppSelector } from "../../../framework/customStore";

import { VehiclePositionInfo } from "../../../models/vehicle/vehiclePosition";
import { VehicleListItemDto } from "../../../models/transport/vehicle";
import { t } from "i18next";
import { getVehicleStatusColorClass, getVehicleStatusDuration, getVehicleStatusText } from "../monitorViewUtils";
import { getWorkTimeTypeColorClass } from "../../../models/workShitTimeSlot/workTimeType";
import { Divider, Grid } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import PersonIcon from "@mui/icons-material/Person";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { Text, BoldText, Subtitle } from "../styledComponents";
import { GpsFixed, LocationOn, Speed, Sync } from "@mui/icons-material";
import { positionStreetAddressReq } from "../../../models/geocode/positionTypes";
import { fetchGeocodedVehicleAddress } from "../../../store/monitorViewSlice";

export const MonitorViewVehicleCurrentStatus = ({
}) => {
    const loading = useAppSelector((state) => state.monitorView.loading);
    const positions = useAppSelector((state) => state.monitorView.positions);
    const vehicles = useAppSelector((state) => state.monitorView.vehicles);
    const selectedVehicleId = useAppSelector((state) => state.monitorView.selectedVehicleId);

    return (
        <>
            {loading ? (
                <Box display="flex" justifyContent="center" p={2}>
                    <CircularProgress />
                </Box>
            ) : (
                <VehicleCurrentDetails lastPosition={positions.find(p => p.vehicleId === selectedVehicleId)} vehicleInfo={vehicles.find(p => p.id === selectedVehicleId)} />
            )}
        </>
    );
};

interface VehicleCurrentDetailsProps {
    lastPosition?: VehiclePositionInfo;
    vehicleInfo?: VehicleListItemDto;
}

const VehicleCurrentDetails = ({ lastPosition, vehicleInfo }: VehicleCurrentDetailsProps) => {
    const dispatch = useAppDispatch();
    const vehicleStreetAddress = useAppSelector((state) => state.monitorView.vehicleStreetAddress);
    const vehicleAddressLoading = useAppSelector((state) => state.monitorView.vehicleAddressLoading);

    useEffect(() => {
        if (!lastPosition?.latitude || !lastPosition?.longitude) 
            return;

        const addressRequest: positionStreetAddressReq = {
            id: vehicleInfo.id,
            lat: lastPosition.latitude,
            lon: lastPosition.longitude
        };

        dispatch(
            fetchGeocodedVehicleAddress(addressRequest) as any
        );
    }, [lastPosition?.latitude, lastPosition?.longitude, dispatch]);


    return (
        <>
            <Grid container>
                <Grid item xs={12} container alignItems="center">
                    <Grid item>
                        <BoldText variant="h6"> {vehicleInfo?.registerNumber} </BoldText>
                        <Subtitle variant="subtitle1"> {vehicleInfo?.brand} </Subtitle>
                    </Grid>
                </Grid>
            </Grid>
            <Divider className="mt-2 mb-2" />
            <Grid container>
                <Grid item xs={12} container alignItems="center">
                    <Grid item>
                        <Box sx={{ marginRight: 1 }}>
                            <LocalShippingIcon />
                        </Box>
                    </Grid>
                    <Grid item>
                        {getVehicleStatusText(lastPosition.driving)}
                    </Grid>
                    <Grid item>
                        <Box sx={{ marginRight: 1 }} className={`text-${getVehicleStatusColorClass(lastPosition.driving)}`}>
                            <BoldText sx={{ marginLeft: 2 }} className={`text-${getVehicleStatusColorClass(lastPosition.driving)}`}>
                                {getVehicleStatusDuration(lastPosition.drivingGmt)}
                            </BoldText>
                        </Box>
                    </Grid>
                </Grid>
                <Grid item xs={12} container alignItems="center">
                    <Grid item>
                        <Box sx={{ marginRight: 1 }}>
                            <Speed />
                        </Box>
                    </Grid>
                    <Grid item>
                        {`${lastPosition.speed} km/h`}
                    </Grid>
                </Grid>
                <Grid item xs={12} container alignItems="center">
                    <Grid item >
                        <Box sx={{ marginRight: 1 }}>
                            <LocationOn />
                        </Box>
                    </Grid>
                    <Grid item>
                        {vehicleAddressLoading ?
                            <Sync />
                            : vehicleStreetAddress}
                    </Grid>
                </Grid>
                <Grid item xs={12} container alignItems="center">
                    <Grid item>
                        <Box sx={{ marginRight: 1 }}>
                            <GpsFixed />
                        </Box>
                    </Grid>
                    <Grid item>
                        {lastPosition.latitude}, {lastPosition.longitude}
                    </Grid>
                </Grid>
            </Grid>
            <Divider className="mt-2 mb-2" />
            <Grid container>
                <Grid item xs={12} container alignItems="center">
                    <Grid item>
                        <Box sx={{ marginRight: 1 }}>
                            <PersonIcon />
                        </Box>
                    </Grid>
                    <Grid item>
                        <Text>{lastPosition?.employeeWorkTimeTypes[0]?.employeeName || t("monitorView.noDriver")} </Text>
                    </Grid>
                </Grid>
                {lastPosition?.employeeWorkTimeTypes[0]?.workTimeTypeType &&
                    <Grid item xs={12} container alignItems="center">
                        <Grid item>
                            <CircleIcon className={`text-${getWorkTimeTypeColorClass(lastPosition?.employeeWorkTimeTypes[0]?.workTimeTypeType)}`} sx={{ display: "inline-block" }} />
                        </Grid>
                        <Grid>
                            <Text className={`text-${getWorkTimeTypeColorClass(lastPosition?.employeeWorkTimeTypes[0]?.workTimeTypeType)}`} sx={{ marginLeft: 1 }}>
                                {lastPosition?.employeeWorkTimeTypes[0]?.workTimeTypeName}
                            </Text>
                        </Grid>
                    </Grid>
                }
            </Grid >
        </>
    );
};